// 工艺流程 · 19 个工序节点数据（酪蛋白产业链数字化/工艺流程 下级页）
// 参照「酪蛋白生产工艺流程」图：16 个主线工序 + 3 个不合格分支处理
// branch: '' 主线 | 'reject' 不合格分支
// video: 生产演示视频（框架期占位 assets/ai/ai.webm，接入实际工位视频后替换 url 即可）

export const PROCESS_STEPS = [
  { key: 'collect',   name: '收集牦牛奶渣', sub: '（牦牛乳）', branch: '', icon: 'box',
    desc: '从牧户与收购站收集新鲜牦牛奶渣（牦牛乳），入库暂存并记录批次来源。' },
  { key: 'qc1',       name: '牦牛奶渣质量检验', sub: '（牦牛乳）', branch: '', icon: 'shield',
    desc: '感官、理化与微生物指标抽检，判定原料是否准入生产。', reject: '不合格' },
  { key: 'pretreat',  name: '预处理', sub: '（制成30目或冷却过滤）', branch: '', icon: 'rings',
    desc: '粉碎制成 30 目或冷却过滤，使原料粒度与状态满足反应要求。' },
  { key: 'pasteurize',name: '巴氏杀菌', sub: '', branch: '', icon: 'waves',
    desc: '巴氏杀菌杀灭致病菌与杂菌，最大限度保留蛋白活性。' },
  { key: 'skim',      name: '净乳脱脂', sub: '', branch: '', icon: 'snow',
    desc: '离心净乳去除杂质，分离脱脂控制脂肪残留。' },
  { key: 'curd',      name: '凝乳形成', sub: '', branch: '', icon: 'scatter',
    desc: '调酸控温使酪蛋白凝聚，形成均匀稳定的凝块结构。' },
  { key: 'cut',       name: '切割凝块', sub: '', branch: '', icon: 'cube',
    desc: '按设定粒度切割凝块，促进乳清析出与均匀干燥。' },
  { key: 'whey',      name: '乳清分离', sub: '', branch: '', icon: 'molecule',
    desc: '离心分离乳清与酪蛋白凝粒，回收乳清副产物。' },
  { key: 'wash',      name: '酪蛋白清洗', sub: '', branch: '', icon: 'waves',
    desc: '多级清水洗涤，降低乳糖与盐类残留，提升纯度。' },
  { key: 'dewater',   name: '脱水', sub: '', branch: '', icon: 'hex',
    desc: '压滤/离心脱水，将清洗后凝粒含水率降至工艺窗口。' },
  { key: 'qc2',       name: '半成品检验', sub: '', branch: '', icon: 'shield',
    desc: '检测半成品水分、纯度与微生物，合格放行进入干燥。', reject: '不合格' },
  { key: 'dry',       name: '干燥', sub: '', branch: '', icon: 'sun',
    desc: '喷雾/流化床干燥至目标水分，控制色泽与溶解性。' },
  { key: 'mill',      name: '研磨', sub: '', branch: '', icon: 'ringbreak',
    desc: '研磨整粒，使产品粒径分布均匀、冲调溶解更快。' },
  { key: 'pack',      name: '包装', sub: '', branch: '', icon: 'grid',
    desc: '自动计量包装，喷码赋批，建立全程追溯档案。' },
  { key: 'qc3',       name: '成品检验', sub: '', branch: '', icon: 'thumb',
    desc: '按企业标准全项检验，出具 COA，判定合格或不合格。', reject: '不合格', pass: '合格' },
  { key: 'store',     name: '存储', sub: '', branch: '', icon: 'check',
    desc: '合格成品入恒温成品库，按批次先进先出发货。' },

  // 不合格分支（3 个）
  { key: 'waste1',    name: '废弃处理', sub: '', branch: 'reject', icon: 'molecule', parent: 'qc1',
    desc: '检验不合格原料按规范无害化处理，严禁流入生产。' },
  { key: 'rework',    name: '返工返料', sub: '', branch: 'reject', icon: 'molecule', parent: 'qc2',
    desc: '半成品不合格返回前端工序返工，复检合格后放行。' },
  { key: 'waste2',    name: '返厂或废弃处理', sub: '', branch: 'reject', icon: 'rings', parent: 'qc3',
    desc: '成品不合格返厂重新处理或无害化废弃，全流程留痕。' },
];

// 各工序演示页的要点补充信息（process-demo.vue 右侧面板使用）
export const STEP_KEYS = {
  collect: ['来源：牧户 / 收购站 / 曲拉收购平台', '暂存温度 ≤ 10 ℃，48h 内投料', '批次留样，来源信息入追溯档案'],
  qc1: ['感官：色泽 / 气味 / 杂质', '理化：水分、蛋白、灰分', '微生物：菌落总数、致病菌不得检出'],
  pretreat: ['粉碎至 30 目或冷却过滤', '粒度合格率 ≥ 95%', '金属探测逐批执行'],
  pasteurize: ['杀菌温度 85~95 ℃', '保温 30 s，杀灭致病菌', '热回收率 ≥ 85%'],
  skim: ['净乳后杂质度 ≤ 2 ppm', '脱脂率 ≥ 98%', '分离温度 35~40 ℃'],
  curd: ['调酸至 pH 4.6', '罐温 38±1 ℃', '凝乳时间 45 min 左右'],
  cut: ['切割粒度 10~20 mm', '切割速度均匀防碎渣', '静置析出乳清'],
  whey: ['离心分离乳清', '乳清回收用于副产物', '凝粒含水率降至 ~60%'],
  wash: ['三级逆流清洗', '水温 20~30 ℃', '乳糖残留达标后进入脱水'],
  dewater: ['压滤脱水至含水率 ~55%', '压滤压力恒定控制', '废水量记录入环保台账'],
  qc2: ['水分、蛋白、灰分抽检', '微生物限量检验', '合格放行 · 不合格返工返料'],
  dry: ['进风 160 ℃ / 排风 75 ℃', '出料水分 4.8~5.6%', '色泽乳白、无焦粉'],
  mill: ['研磨整粒，粒径均一', '过筛去团块', '溶解时间达标'],
  pack: ['自动计量 ±2 g', '封口强度抽检', '喷码赋批、建立追溯'],
  qc3: ['按企业标准全项检验', '出具 COA 报告', '合格入存储 · 不合格返厂或废弃'],
  store: ['恒温库 10~20 ℃', '批次先进先出', '库存与温湿度在线监测'],
  waste1: ['无害化处理规范执行', '处理过程留痕', '不可流入生产环节'],
  rework: ['返回前端工序返工', '返工批次单独标识', '复检合格后方可放行'],
  waste2: ['成品不合格隔离封存', '返厂重处理或废弃', '全流程记录可追溯'],
};

export const FLOW_TITLE = '酪蛋白生产工艺流程';
